import React, { useState } from "react";
import "./styles.css";
import Cardamagepage from "../Cardmagepage";
import NativeInspectionCamera from "../components/NativeInspectionCamera";
import { exitImmersiveMode } from "../utils/immersiveMode";

export default function CarDamgeCamra({ id, close }) {
  const [showdamagecolor, setshowdamagecolor] = useState(false);
  const [img, setimg] = useState("");

  const closeCamera = async () => {
    await exitImmersiveMode();
    if (typeof close === "function") {
      close(true);
    }
  };

  if (showdamagecolor) {
    return (
      <Cardamagepage id={id} image={img} close={setshowdamagecolor} />
    );
  }

  return (
    <NativeInspectionCamera
      onCapture={async (dataUrl) => {
        setimg(dataUrl);
        setshowdamagecolor(true);
      }}
      onCancel={closeCamera}
      cancelLabel="Cancel"
      hint="Photograph damage on the car, then tap capture. Cancel if there is no damage."
      rotateDescription="Hold your phone horizontally to photograph vehicle damage."
      titleBar="Photograph damage on your car"
    />
  );
}
